import { Button } from '@/components/elements/forms/buttons';
import { ButtonProps } from '@/components/elements/forms/buttons/Button/Button';
import { classnames } from '@/helpers';
import { customTwMerge } from '@/helpers/theme';
import CroLabel, { CroLabelProps } from '../CroLabel';

type ButtonAndPriceContainerProps = {
  originalPrice?: string;
  price: string;
  duration?: string;
  croLabelProps?: CroLabelProps;
  buttonProps?: {
    label: string;
    onClick: () => void;
  } & ButtonProps;
};

const ButtonAndPriceContainer = ({
  originalPrice,
  price,
  duration,
  buttonProps,
  croLabelProps,
}: ButtonAndPriceContainerProps) => {
  const handleButtonClick = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    e.preventDefault();
    buttonProps.onClick();
  };

  return (
    <div className="gap-md flex w-full items-center justify-between">
      <div className="space-y-2xs">
        {/* Price */}
        <div className="space-x-xs flex items-center">
          <span className={classnames('text-l font-bold', originalPrice ? 'text-fg_highlight' : 'text-fg_primary')}>
            {price}
          </span>
          {originalPrice && <span className="text-fg_secondary text-m line-through">{originalPrice}</span>}
        </div>

        {/* Duration and CRO label */}
        <div className="space-x-xs flex items-center">
          {duration && <span className="text-fg_secondary text-m">{duration}</span>}
          {croLabelProps && <CroLabel {...croLabelProps} className="w-auto whitespace-nowrap" />}
        </div>
      </div>

      {/* Book button */}
      {buttonProps && (
        <Button
          {...buttonProps}
          className={customTwMerge(buttonProps.className || '', 'flex-shrink-0')}
          onClick={handleButtonClick}
        />
      )}
    </div>
  );
};

export default ButtonAndPriceContainer;
